module.exports = __webpack_public_path__ + "img/Terraform-Inspect-Portrait.30e51ae6.png";